import React from 'react';
import Icon from "../../../Icon";
import crossIcon from "../../../../assets/icons/cross.svg";
import VimeoLink from '../VimeoLink';
import {
  ErrorContainer,
  IconContainer,
  ErrorMessage,
  LinkContainer
} from './styles';

interface VimeoErrorFallbackProps {
  url: string;
  showLink?: boolean;
  message?: string;
}

const VimeoErrorFallback: React.FC<VimeoErrorFallbackProps> = ({
  url,
  showLink = true,
  message = "El video cargado es invalido o no cuenta con las configuraciones de privacidad adecuadas para ser utilizado en otros sitios. Por ello, mostraremos directamente el enlace."
}) => {
  if (showLink) {
    return <VimeoLink url={url} />;
  }

  return (
    <ErrorContainer>
      <IconContainer>
        <Icon size={"24px"} color="white" icon={crossIcon} />
      </IconContainer>
      <ErrorMessage>
        {message}
      </ErrorMessage>
      <LinkContainer>
        <VimeoLink url={url} />
      </LinkContainer>
    </ErrorContainer>
  );
};

export default VimeoErrorFallback;
